import React, { useState, useRef, useEffect, Fragment } from 'react';
import { Section, Select, Time_period_selector} from '../../../../components';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import Timeline_item_chart from './Timeline_item_chart';
import Generate_chart_popup from './CRUD_popups/Generate_chart_popup';
import Delete_chart_popup from './CRUD_popups/Delete_chart_popup';
import { connect } from 'react-redux';

function getTimeArray(dates_back, time_frame, props, dimension_key=undefined) {
    let year_labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']; let labels = [];
    let start_date = undefined; let end_date = undefined; let m = new Date(); let y = undefined; let time_title = 'All time'; let date = new Date();

    if (time_frame == 'day_of_month') { m = date.getMonth(); y = date.getFullYear(); let ys = 0; if (dates_back > 12) { ys = Math.floor(dates_back / 12); } y = y - ys; m = m - (dates_back - ys * 12); if (m < 0) { m = 12 + m; y = y - 1; } time_title = year_labels[m] + ' ' + y; start_date = new Date(y, m, 1); let nm = m + 1; let ny = y; if (nm == 12) { nm = 0; ny = y + 1; } end_date = new Date(ny, nm, 0); }
    else if (time_frame == 'time') { start_date = new Date(date.getFullYear(), date.getMonth(), date.getDate() - dates_back, 0, 0, 0, 0), end_date = new Date(date.getFullYear(), date.getMonth(), date.getDate() - dates_back, 23, 59, 59, 999), time_title = `${start_date.toLocaleDateString([], { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}`; }
    else if (time_frame == 'day_of_week') { let m = date.getMonth(); let y = date.getFullYear(); let dayOfWeek = date.getDay(); start_date = new Date(y, m, date.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1) - (dates_back * 7), 0, 0, 0, 0); end_date = new Date(y, m, date.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1) + 6 - (dates_back * 7), 23, 59, 59, 999); time_title = `${start_date.getDate()}/${start_date.getMonth() + 1}/${start_date.getFullYear()} - ${end_date.getDate()}/${end_date.getMonth() + 1}/${end_date.getFullYear()}`;}
    else if (time_frame == 'month') { start_date = new Date(date.getFullYear() - dates_back, 0, 1), end_date = new Date(date.getFullYear() - dates_back + 1, 0, 0), time_title = `${start_date.getFullYear()}`; }
    else if (time_frame == 'year') { start_date = new Date(new Date(props.workspace.created_at).getFullYear(), 0, 1, 0, 0, 0, 0); end_date=new Date(); time_title='All time';}
    
    let dimension=time_frame; if(dimension_key!=undefined && props[dimension_key]!=undefined && props[dimension_key]!=null){dimension=props[dimension_key];}
    
    if (dimension == 'time') { labels = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']; }
    else if (dimension == 'week_day'){labels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];}
    else if (dimension == 'day_of_week') {labels = Object.fromEntries(Array.from({ length: 7 }, (_, i) => {const d = new Date(start_date.getTime()  - start_date.getTimezoneOffset()*60000 + i * 86400000); return [ d.toISOString().slice(0, 10), d.toUTCString().split(",")[0]];}));}
    else if (dimension == 'day_of_month') { labels = Object.fromEntries(Array.from({ length: new Date(y, m + 1, 0).getDate() }, (_, i) => [`${y}-${String(m + 1).padStart(2, '0')}-${String(i + 1).padStart(2, '0')}`, String(i + 1).padStart(2, '0')])); }
    else if (dimension == 'month') { labels = year_labels; }
    else if (dimension == 'year') { labels = Object.fromEntries(Array.from({ length: end_date.getFullYear() - start_date.getFullYear() + 1 }, (_, i) => { const yearDate = new Date(start_date.getFullYear() + i, 0, 1); return [yearDate.getFullYear().toString(), yearDate.getFullYear().toString()];})); }

    return { month: m, year: y, time_title: time_title, start_date: start_date, end_date: end_date, labels: labels };
}


function Analytics(props) {
    const [generate_chart_popup, setGenerateChartPopup] = useState(undefined);
    const [delete_chart_popup, setDeleteChartPopup] = useState(undefined); 
    const [dashboard_id, setDashboardId] = useState(undefined);
    const [time_frame, setTimeFrame]=useState('day_of_month');
    const [dates_back, setDatesBackFunc] = useState(0);
    const [team_member, setTeamMember] = useState('all_users');
    

    let dates_back_funcs = useRef({});
    let timeline_item_data = [];
    if (props.timeline_item_data != undefined) { timeline_item_data = props.timeline_item_data; }

    useEffect(() => {
        if (props.html_templates==undefined){ props.getTemplates(); }
        if (props.queues == undefined) { props.index_queues(); }
        if (props.analytics_settings == undefined) { props.get_analytics_data(); }
        if (props.message_types == undefined){ props.getMessageTypes();}
    }, []);


    function setDatesBack(x, ed = {}) {
        for (let id in dates_back_funcs.current) { dates_back_funcs.current[id](x, { time_frame:ed.time_frame, team_member:ed.team_member}); }
        setDatesBackFunc(x);
    }


    let owners = [{ id: 'all', name: 'Compare Users' }, { id: 'all_users', name: 'All users' }]; for (let k in props.workspace_data.user_workspaces) {
        if (props.workspace_data.user_workspaces[k].superuser != true && props.workspace_data.user_workspaces[k].superuser != 1) {
            if (props.workspace_data.admin != true && props.me.id == props.workspace_data.user_workspaces[k].user_id && team_member != props.workspace_data.user_workspaces[k].id) { setTeamMember(props.workspace_data.user_workspaces[k].id); }
            owners.push({ id: props.workspace_data.user_workspaces[k].id, name: props.workspace_data.user_workspaces[k].first_name + ' ' + props.workspace_data.user_workspaces[k].last_name });
        }
    }
    let queues = [{ id: 'all', name: 'All' }];
    if (props.queues != undefined) { for (let k in props.queues) { queues.push({ id: k, name: props.queues[k].name }); } }
    let dashboard = undefined;
    if (props.analytics_settings != undefined) { if (dashboard_id == undefined) { setDashboardId(props.analytics_settings[0].id); } for (let ad of props.analytics_settings) { if (ad.id == dashboard_id) { dashboard = ad; } } }

    let ta=getTimeArray(dates_back, time_frame, props);
    let time_title = ta.time_title; 
    

    let queue_label_dic = {};
    if (queues != undefined) { for (let q of queues) { if (q.id != 'all') { queue_label_dic[q.id] = q.name; } } }
    let html_templates_dic= {null:'No template'}; let html_templates=[];
    if(props.html_templates!=undefined){for(let k in props.html_templates){
        html_templates_dic[k]=props.html_templates[k].name;
        html_templates.push({ id: k, name: props.html_templates[k].name });
    }}

    let message_type_dic = {}; if (props.message_types != undefined) { for(let mt of props.message_types){message_type_dic[mt.id]=mt.name;}} 
    
//'primary' 'secondary' 'tertiary' "green" "yellow" "red" "black" "purple" "cyan" "magenta" "pink"

    //DEFAULT ORDER FOR COLOURS IS 
    let analytics_types={
        timeline_items:{
            notes:{

            },
            phone_calls: { 
                default:'timeline_item_sub_type',
                timeline_item_sub_type:{0:{title:'Incoming', colour:'green'}, 1:{title:'Outgoing', colour:'primary'}, 2:{title:'Voicemail', colour:'secondary'}, 3:{title:'No answer', colour:'red'}, 4:{title:'Live message', colour:'yellow'}, 5:{title:'Busy', colour:'purple'}, 6:{title:'Wrong number', colour:'black'}},
            },
            emails: {
                default:'timeline_item_email_sub_type',
                timeline_item_email_sub_type:{ 0:{title: 'Emails sent', colour:'primary'}, 'clicked':{title:'Clicked', colour:'green'}, 'error':{title:'Error', colour:'red'}, 1:{title: 'Inbound emails', colour:'secondary'}, 2:{title: 'Scheduled', colour:'tertiary'}, 3:{title: 'Canceled', colour:'purple'}, 4:{title: 'Paused emails', colour:'black'} },
                html_template_id:html_templates_dic
            },
            meetings: {
                default: 'status',
                timeline_item_sub_type:{0:{title:'Phone meeting', colour:'primary'}, 1:{title:'Video meeting', colour:'secondary'}, 2:{title:'In person meeting', colour:'tertiary'}},
                meeting_status:{5:{title:'Completed', colour:'secondary'}, 3:{title:'Cancelled', colour:'red'}, 4:{title:'No Show', colour:'black'}, 6:{title:'All declined', colour:'purple'},  0:{title:'Scheduled', colour:'primary'}, 1:{title:'Confirmed', colour:'green'}, 2:{title:'Rescheduled', colour:'tertiary'}}
            },
            messages: {
                default:'timeline_item_sub_type',
                timeline_item_sub_type:{1:{title:'Inbound', colour:'secondary'}, 0:{title:'Outbound', colour:'primary'} },
                message_type:message_type_dic
            },
            tasks_completed:{
                default:'task_queue_id',
                task_queue_id:queue_label_dic,
                timeline_item_sub_type: {0:{title:'Send email', colour:'primary'},1:{title:'Research note', colour:'tertiary'},2:{title:'Phone call', colour:'secondary'},3:{title:'Other', colour:'yellow'},4:{title:'Send message', colour:'purple'}}
            },
            tasks_overdue:{
                default:'task_queue_id',
                task_queue_id: queue_label_dic,
                timeline_item_sub_type: {0:{title:'Send email', colour:'primary'},1:{title:'Research note', colour:'tertiary'},2:{title:'Phone call', colour:'secondary'},3:{title:'Other', colour:'yellow'},4:{title:'Send message', colour:'purple'}}
            }
        }
    };
    
    let category_dictionary={
        timeline_item_sub_type:'Sub type',
        timeline_item_email_sub_type:'Sub type',
        html_template_id:'Html template',
        task_queue_id:'Task queue',
        meeting_status:'Meeting status',
        message_type:'Message type'
    }

    return (
        <Fragment>
            {(dashboard == undefined) ? undefined : <Section maxWidth='10000000px' action={<Button variant='contained' color='primary' disabled={(dashboard.analytics_graphs.length >= 6) ? true : false} onClick={() => { setGenerateChartPopup('new'); }}>+ Add chart</Button>}>
                <Typography style={{ marginTop: '-25px' }}>{dashboard.name}</Typography>
                {(props.workspace != undefined && props.workspace.admin == true) ? <div style={{ width: '200px', position: 'absolute', top: '50px', left: '15px', zIndex: '10' }}><Select no_field  size='small' variant='outlined' name='user_workspace_id' value={team_member} onChange={(e) => { setTeamMember(e.target.value); setDatesBack(dates_back, { time_frame:time_frame, team_member: e.target.value }); }} style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px', height:'40px'}} select_data={owners} /></div> : null}
                <Time_period_selector time_title={time_title} time_frame={time_frame} dates_back={dates_back} setTimeFrame={setTimeFrame} setDatesBack={setDatesBack} />

            </Section>}
            <Grid container style={{ width: '100%' }}>
                {(dashboard == undefined) ? undefined : dashboard.analytics_graphs.map(function (ag) {
                    return (<Grid item xl={4} lg={6} md={12} sm={12} xs={12}><Timeline_item_chart {...props} getTimeArray={getTimeArray} chart_id={ag.id} category_dictionary={category_dictionary} timeline_item_sub_types={analytics_types.timeline_items} setDeleteChartPopup={setDeleteChartPopup} setGenerateChartPopup={setGenerateChartPopup} id={ag.id} setDatesBackFunc={(func) => { dates_back_funcs.current[ag.id] = func; }} analytics_dashboard_id={ag.analytics_dashboard_id} {...ag} ag={ag} team_member={team_member} dimension_1={ag.dimension_1} dimension_2={ag.dimension_2} segment={ag.segment} category={ag.category} queues={queues} db_data={timeline_item_data} /></Grid>)
                })}
            </Grid>
            <div style={{ height: '30px' }} />
            {(generate_chart_popup != undefined) ? <Generate_chart_popup {...props} category_dictionary={category_dictionary} timeline_item_sub_types={analytics_types.timeline_items} dashboard={dashboard} id={(generate_chart_popup=='new')?undefined:generate_chart_popup} analytics_dashboard_id={dashboard_id} queues_data={queues} html_templates_data={html_templates} handleClose={() => { 
                setGenerateChartPopup(undefined); }} /> : null}
            {(delete_chart_popup !=undefined) ? <Delete_chart_popup id={delete_chart_popup} handleClose={() => { setDeleteChartPopup(undefined); }} /> : null}
        </Fragment>
    )
}


export default connect(ss, dd)(Analytics);


function ss(state) {
    return {
        message_types: state.account.message_types,
        refresh_message_types: state.account.refresh,
        refresh: state.analytics.refresh,
        html_templates: state.templates.templates,
        timeline_item_data: state.analytics.data,
        queues: state.lists.queue_data,
        analytics_settings: state.analytics.settings
    }
}

function dd(dispatch) {
    return {
        getTemplates: () => { dispatch({ type: 'REQUEST_INDEX_HTML_TEMPLATES' }) },
        getMessageTypes: () => { dispatch({ type: 'REQUEST_INDEX_MESSAGE_TYPES' }) },
        getTimelineItemsData: (user_workspace_id, start_date, end_date, type, sub_type) => { dispatch({ type: 'REQUEST_INDEX_TIMELINE_ITEMS', user_workspace_id: user_workspace_id, start_date: start_date, end_date: end_date, d_type: type, sub_type: sub_type }); },
        index_queues: () => { dispatch({ type: 'REQUEST_QUEUE_INDEX' }) },
        get_analytics_data: () => { dispatch({ type: 'REQUEST_GET_ANALYTICS_SETTINGS' }) },
        createUpdateChart: (val) => { dispatch({ type: 'REQUEST_CREATE_UPDATE_ANALYTICS_CHART', val: val }) },
        deleteChart: (id) => { dispatch({ type: 'REQUEST_DELETE_ANALYTICS_CHART', id: id }) }
    }
}
